module.exports = __webpack_public_path__ + "img/homepage-quick-links-hyundai.8fa15a5f.jpg";